// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BlockOutlinedSvg from "@ant-design/icons-svg/es/asn/BlockOutlined";
import AntdIcon from '../components/AntdIcon';

var BlockOutlined = function BlockOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BlockOutlinedSvg
  }));
};

BlockOutlined.displayName = 'BlockOutlined';
export default React.forwardRef(BlockOutlined);